import React from 'react';
import { useNavigate } from 'react-router-dom';
import MultiQuoteForm from '../components/MultiQuoteForm';
import { useQuotes } from '../hooks/useQuotes';
import { Quote } from '../types';
import { ArrowLeft } from 'lucide-react';

export default function AddQuotePage() {
  const { addQuote } = useQuotes();
  const navigate = useNavigate();

  const handleAddQuotes = async (quotes: Array<Omit<Quote, 'id'>>) => {
    let allSuccess = true;
    const results = [];

    for (const quote of quotes) {
      const result = await addQuote(quote);
      results.push(result);
      if (!result.success) {
        allSuccess = false;
      }
    }

    if (allSuccess) {
      navigate('/quotes');
    }
    return results;
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <button
          onClick={() => navigate('/quotes')}
          className="mb-6 flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
          <span>Back to Quotes</span>
        </button>
        
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Add New Quotes</h1>
          <p className="mt-2 text-gray-600">
            Add multiple quotes at once to your collection
          </p>
        </div>

        <MultiQuoteForm onSubmit={handleAddQuotes} />
      </div>
    </div>
  );
}